export default __webpack_public_path__ + "static/media/ledDriver.4d5f6da4.svg";